/**
 * @generated SignedSource<<0396169b641922010d30ecba4e1fce13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FilterSetDeleteMutation$variables = {
  filterSetId: number;
};
export type FilterSetDeleteMutation$data = {
  readonly delete_user_filter_sets_by_pk: {
    readonly id: number;
  } | null | undefined;
};
export type FilterSetDeleteMutation = {
  response: FilterSetDeleteMutation$data;
  variables: FilterSetDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterSetId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "filterSetId"
      }
    ],
    "concreteType": "user_filter_sets",
    "kind": "LinkedField",
    "name": "delete_user_filter_sets_by_pk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterSetDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterSetDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9997f52f6d4c3f165c900de5317b1ae0",
    "id": null,
    "metadata": {},
    "name": "FilterSetDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation FilterSetDeleteMutation(\n  $filterSetId: Int!\n) {\n  delete_user_filter_sets_by_pk(id: $filterSetId) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b58d8449ed34c1a895e3d72573e5688";

export default node;
